export const EnDataGridTooltipLocation = Object.freeze({
  TOP: 'top',
  BOTTOM: 'bottom',
  START: 'start',
  END: 'end',
});